import flattenWorkflowSteps from '@/lib/workflows/flattenWorkflowSteps.js';

// Every step of the draft by id, loop children and branch steps included, so a tool call that names a
// nested step still resolves.
const buildWorkflowStepsById = (steps) => {
  const stepsById = new Map();

  flattenWorkflowSteps(steps).forEach((step) => {
    const stepId = String(step?.stepId || '').trim();

    if (stepId) {
      stepsById.set(stepId, step);
    }
  });

  return stepsById;
};

export default buildWorkflowStepsById;
